import React, { useState, useEffect,useRef } from "react";
import {
  Card,
  Button,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";

export default function FoodCoupens() {
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [coupenData, setCoupenData] = useState("");
  const [coupenName, setCoupenName] = useState("");
  const [coupenDate, setCoupenDate] = useState("");
  const [coupenTime, setCoupenTime] = useState("");
  const [coupenDescription, setCoupenDescription] = useState("");
  const [coupenMinimumAmount, setCoupenMinimumAmount] = useState("");
  const [coupenMaxDiscount, setCoupenMaxDiscount] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const handleShow = () => {
    setCoupenName("");
    setCoupenDescription("");
    setCoupenMaxDiscount("");
    setCoupenDate("");
    setCoupenTime("");
    setCoupenMinimumAmount("");
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false);
    setDiscountAmount("");
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food-admin/get-all-food-coupon`)
      .then((res) => {
        setSpinner(false);
        console.log("result", res.data.couponDetails);
        setCoupenData(res.data.couponDetails);
        setData(document.querySelectorAll("#job_data tbody tr"))
      });
  }
  function generateRandAlphaNumStr(len) {
    var rdmString = "";
    for (
      ;
      rdmString.length < len;
      rdmString += Math.random().toString(36).substr(2)
    );
    return rdmString.substr(0, len);
  }
  useEffect(() => {
    getData();
  }, []);

  function saveCoupen(e) {
    e.preventDefault();
    console.log("dates", coupenDate, coupenTime);
    var vals = coupenDate.split("-");
    var year = vals[0];
    var month = vals[1];
    var day = vals[2];

    var valTime = coupenTime.split(":");
    var hour = valTime[0];
    var minute = valTime[1];
    console.log("dates", year, month, day, hour, minute);
    let coupenData = {
      Name: coupenName,
      Description: coupenDescription,
      Percentage: discountAmount,
      MaxAmount: coupenMaxDiscount,
      MinAmount: coupenMinimumAmount,
      Code: generateRandAlphaNumStr(12),
      ExpDate: {
        Year: year,
        Month: month,
        Day: day,
        Hour: hour,
        Minute: minute,
      },
    };

    let data = {
      data: JSON.stringify(coupenData),
    };
    axios
      .post(`${Baseurl.baseurl4}/go-food-admin/create-food-coupon`, data)
      .then((response) => {
        if (response.data.status) {
          getData();

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {});
  }
  function deleteCoupen(e) {
    e.preventDefault();
    axios
      .delete(`${Baseurl.baseurl4}/go-food-admin/delete-food-coupon/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      });

    handleClose();
  }

  function updateCoupenField(e) {
    e.preventDefault();
    console.log("dates", coupenDate, coupenTime);
    var vals = coupenDate.split("-");
    var year = vals[0];
    var month = vals[1];
    var day = vals[2];
    var valTime = coupenTime.split(":");
    console.log("valminuts",valTime );
    var hour = valTime[0];
    var min = valTime[1];
    let coupenData = {
      name: coupenName,
      description: coupenDescription,
      code: generateRandAlphaNumStr(12),
      minAmount: coupenMinimumAmount,
      maxAmount: coupenMaxDiscount,
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: min,
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/update-food-coupon/${bannerId}`,
        coupenData
      )
      .then((response) => {
        if (response.data.status) {
          getData();

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      });
    handleClose();
  }
  function setUpdateValues(val) {
    setDiscountAmount(val.Percentage);
    setCoupenName(val.Name);
    setCoupenDescription(val.Description);
    setCoupenMaxDiscount(val.MaxAmount);
    setBannerId(val._id);
    setCoupenMinimumAmount(val.MinAmount);
    const d = new Date(
      val.ExpDate.Year,
      val.ExpDate.Month - 1,
      val.ExpDate.Day
    );
    if (String(Math.abs(val.ExpDate.Hour)).length === 1) {
      setCoupenTime(`0${val.ExpDate.Hour}:${val.ExpDate.Minute}`);
    } else {
      setCoupenTime(`${val.ExpDate.Hour}:${val.ExpDate.Minute}`);
    }

    setCoupenDate(moment(d).format("YYYY-MM-DD"));
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus ? (
            <h4>
              Are you sure !! you want to delete Coupen
              <text className="text-danger">{coupenName}</text>
            </h4>
          ) : (
            <div className="card">
              <div className="card-body">
                <form
                  onSubmit={(e) => {
                    saveCoupen(e);
                  }}
                >
                  <div className="row">
                    <div className="col-sm-2 ">
                      <label>
                        Coupen Name<span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenName}
                        onChange={(e) =>
                          setCoupenName(e.target.value.toUpperCase())
                        }
                        placeholder="Enter Coupen Name"
                        required
                      />
                    </div>
                    <div className="col-sm-2 ">
                      <label>Discount Percentage</label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={discountAmount}
                        onChange={(e) => setDiscountAmount(e.target.value)}
                        placeholder={`Enter Discount percentage`}
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-2">
                      <label>
                        Min Amount <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenMinimumAmount}
                        onChange={(e) => setCoupenMinimumAmount(e.target.value)}
                        placeholder="Enter Minimum Amount"
                        required
                      />
                    </div>
                    <div className="col-sm-2 mt-2">
                      <label>Max Amount</label>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenMaxDiscount}
                        onChange={(e) => setCoupenMaxDiscount(e.target.value)}
                        placeholder="Enter Max Discount"
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-sm-2 mt-2">
                      <label>Expiry Date</label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        required
                        value={coupenDate}
                        onChange={(e) => {
                          setCoupenDate(e.target.value);
                        }}
                        placeholder="Enter Coupen Max Discount"
                      />
                    </div>
                    <div className="col-sm-2 mt-2">
                      <label>Expiry Time</label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={coupenTime}
                        onChange={(e) => {
                          setCoupenTime(e.target.value);
                        }}
                        placeholder="Enter"
                        required
                      />
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-sm-2">
                      <label>Coupen Description</label>
                    </div>
                    <div className="col-sm-4">
                      <textarea
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        rows={2}
                        value={coupenDescription}
                        onChange={(e) => setCoupenDescription(e.target.value)}
                        placeholder="Enter Coupen Description"
                      />
                    </div>
                  </div>

                  {updateStatus && (
                    <div className="row">
                      <div>
                        <Button
                          className="mt-3"
                          variant="primary"
                          onClick={(e) => {
                            updateCoupenField(e);
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                  )}

                  {updateStatus ? null : (
                    <div>
                      <input
                        className="btn btn-primary mt-4"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              </div>
            </div>
          )}
        </Modal.Body>

        {deleteStatus && (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={(e) => {
                deleteCoupen(e);
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      <Card.Header>
        <div>
          
        </div>
      <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleShow}
              >
                Add Coupen
              </button>
            </div>
      </Card.Header>
      <Card.Body>
      <div id="job_data" className="dataTables_wrapper ">
        <div style={{ padding: 20 }} className="flex-container">
          <div>
           
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive className="text-white text-center">
                <thead>
                  <tr>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Creator</strong>
                    </th>
                  
                    <th>
                      <strong>Minimum Order</strong>
                    </th>

                    <th>
                      <strong>Max Discount</strong>
                    </th>

                    <th>
                      <strong>Type</strong>
                    </th>
                  

                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {coupenData &&
                    coupenData.map((val) => (
                      <tr>
                        <td>{val.CouponCode}</td>
                        <td>{val.CouponCreated}</td>
                        <td>{val.CouponMaximumOrderValue}</td>
                        <td>{val.CouponTypeCode===2?val.CouponDiscountAmount:val.CouponTypeCode===1?val.CouponMaximumDiscount:val.CouponTypeCode===4&&"Free Shipping"}</td>
                        <td>{val.CouponType}</td>
                       

                        <td>{val.Active ? "Active" : "Inactive"}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setUpdateValues(val);
                                  setUpdateStatus(true);
                                  setDeleteStatus(false);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCoupenName(val.Name);
                                  setDeleteStatus(true);
                                  setShow(true);
                                  setBannerId(val._id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            <>
              {!coupenData && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Add Coupens
                </Alert>
              )}
                
            </>
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      </Card.Body>
    </Card>
  );
}
